module.exports = __webpack_public_path__ + "files/04e14cab1eb9a4b0d9315752229b0034.png";